import { render, staticRenderFns } from "./AdvantageCard.vue?vue&type=template&id=6a1a4020&scoped=true"
import script from "./AdvantageCard.vue?vue&type=script&lang=js"
export * from "./AdvantageCard.vue?vue&type=script&lang=js"
import style0 from "./AdvantageCard.vue?vue&type=style&index=0&id=6a1a4020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a4020",
  null
  
)

export default component.exports